<template>
  <div class="steps1-content">
    <div>
      <div>
        <span>账号：</span>
        <input type="text" v-model="id" />
      </div>
      <div>
        <span>验证码：</span>
        <input type="text" v-model="code" />
        <span>验证码</span>
      </div>
      <div @click="handleSubmit">确定</div>
    </div>
    <div></div>
    <div>
      <div>
        <span></span>
        <span>操作说明</span>
      </div>
      <div>1、输入账号+验证码进行密码重置.</div>
      <div>2、账号输入错误时提示“请输入正确的账号”.</div>
      <div>3、验证码输入错误时提示“请输入正确的验</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Steps1',
  props: ['toNext'],
  data() {
    return {
      id: '',
      code: ''
    }
  },
  methods: {
    handleSubmit() {
      this.toNext()
    }
  }
}
</script>
<style lang="scss" scoped>
.steps1-content {
  display: flex;
  justify-content: center;
  align-items: center;
  > div:first-child {
    > div {
      > span {
        display: inline-block;
      }
      > span:first-child {
        width: 70px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        text-align: right;
        margin-right: 20px;
      }
      > input {
        outline: none;
        border: none;
        background: none;
      }
    }
    > div:first-child {
      margin-bottom: 23px;
      > input {
        width: 208px;
        height: 30px;
        border: 1px solid #0345ad;
      }
    }
    > div:nth-child(2) {
      margin-bottom: 43px;
      > input {
        width: 118px;
        height: 30px;
        border: 1px solid #0345ad;
        margin-right: 20px;
      }
      > span:last-child {
        width: 70px;
        height: 30px;
        border: 1px solid #0345ad;
        background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
    }
    > div:last-child {
      width: 152px;
      height: 38px;
      background: linear-gradient(90deg, #105abf 0%, #486dee 100%);
      border-radius: 19px;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      margin: 0 auto;
    }
  }
  > div:nth-child(2) {
    width: 0;
    height: 337px;
    border-left: 2px dashed #c6c6c6;
    margin: 0 124px 0 174px;
  }
  > div:last-child {
    > div:first-child {
      margin-bottom: 32px;
      > span:first-child {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #d00d0d;
        border-radius: 50%;
        margin-right: 6px;
        vertical-align: center;
      }
    }
    > div:not(div:first-child) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 30px;
    }
  }
}
</style>
